import { useState } from "react";
import { state } from "../state/workspaceStore.js";
// One shared workspace; pages and controller never maintain competing record copies.
export function useWorkspace() {
  const [, setRevision] = useState(0);
  state.refresh = () => setRevision((n) => n + 1);
  return state;
}
